import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({ standalone:false,
  selector: 'app-filesharing-disconnect-dialog',
  templateUrl: './filesharing-disconnect-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./filesharing-disconnect-dialog.component.scss']
})
export class FileSharingDisconnectDialogComponent {
  public title: string= "Disconnect this file sharing account?";
  public message: string = "Disconnecting this file sharing account will disable file synchronization with detamoov.";
  public type: string ="";
  public account: string="";
  public confirmButtonText = "Disconnect";
  public cancelButtonText = "Cancel";

  constructor(@Inject(MAT_DIALOG_DATA) private data: any, private dialogRef: MatDialogRef<FileSharingDisconnectDialogComponent>) {
    if(data){
      this.type=data.type;
      this.account=data.account;
    }
  }

  public onCancelClick(){
    this.dialogRef.close(false);
  }

  onConfirmClick(): void {
    this.dialogRef.close(true);
  }
}
